'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNotDisplayedIds = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _dotstatsuiteSdmxjs = require('@sis-cc/dotstatsuite-sdmxjs');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getNotDisplayedValues = function getNotDisplayedValues(annot) {
  if (R.isNil(annot)) {
    return {};
  }
  var ids = R.split(',', annot.title || '');
  return R.reduce(function (acc, entry) {
    if (R.isEmpty(entry)) {
      return acc;
    }
    var parsed = R.split('=', entry);
    var dimensionId = parsed[0];
    if (R.length(parsed) === 1) {
      return R.assoc(dimensionId, dimensionId, acc);
    }
    var values = R.split('+', parsed[1]);
    if (R.length(values) === 1 && R.isEmpty(values[0])) {
      return R.assoc(dimensionId, dimensionId, acc);
    }
    return R.reduce(function (_acc, val) {
      var _val = val;
      if (R.isEmpty(val)) {
        return _acc;
      }
      if (R.test('/[()]/')) {
        _val = R.replace(/[()]/g, '')(val);
      }
      var key = R.isEmpty(_val) ? dimensionId : dimensionId + '.' + _val;
      return R.assoc(key, key, _acc);
    }, acc, values);
  }, {}, ids);
};

var getNotDisplayedIds = exports.getNotDisplayedIds = function getNotDisplayedIds(annotations) {
  return R.pipe(R.find(R.propEq('type', 'NOT_DISPLAYED')), R.converge(function (hiddenValues, hiddenCombinations) {
    return {
      hiddenValues: hiddenValues,
      hiddenCombinations: hiddenCombinations
    };
  }, [getNotDisplayedValues, function () {
    var annot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { title: '' };
    return (0, _dotstatsuiteSdmxjs.getNotDisplayedCombinations)(annot);
  }]))(annotations);
};